import './style.scss'

import { ERROR, LOADING, READY, useVisualState } from '../../../hooks/useVisualState'
import React, { useEffect } from 'react'

import { oldGet } from '../../../helpers/requestOld'
import { withRouter } from 'react-router-dom'

const TeamView = withRouter(({ team_id, team, history }) => {
  return (
    <div
      className='hack-team-avatar-editor'
      onClick={() => history.push('/soccer/old/teams/' + team_id + '/players')}
    >
      <div className='-logo'>
        <img src={team.logo} alt='' />
      </div>
      <div>{team.name}</div>
    </div>
  )
})

const OldPlayersView = () => {
  const [[teamsState, teams], setTeams] = useVisualState()
  const seasonId = '5f07675ae4b0314515e4e950'

  useEffect(() => {
    setTeams(LOADING)
    oldGet('/teams/' + seasonId)
      .then((response) => {
        setTeams(READY, response)
      })
      .catch((error) => {
        setTeams(ERROR, error)
      })
  }, [setTeams])

  return (
    <div>
      {teamsState === READY &&
        Object.keys(teams).map((team_id) => {
          const team = teams[team_id]
          return <TeamView key={team_id} team_id={team_id} team={team} />
        })}
      {teamsState === ERROR && <div>Error: {teams.code}</div>}
    </div>
  )
}

export default withRouter(OldPlayersView)
